import { ActionTypes } from '../constants';

const defaults = {
  checks: new Map(),
  timestamp: new Date().getTime(),
};

export interface CheckState {
  checks: Map<any>;
  timestamp: Number;
}

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: CheckState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_CHECK: {
      const { checks } = action.payload;
      return {
        ...state,
        checks: checks,
        timestamp: Date.now(),
      };
    }
    default:
      return { ...state };
  }
};
